import { useTranslation } from "react-i18next";

import { Text } from "components";

import DashboardMessagesContent from "../shared/DashboardMessagesContent";

import classes from "./MessagesSection.module.css";

const MessagesSection = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Text className={classes.title}>{t("chat.title")}</Text>

      <div className={classes.list}>
        <DashboardMessagesContent />
      </div>
    </div>
  );
};

export default MessagesSection;
